import React from "react";
import $ from "./footer.module.scss";

export const Footer = () => {
  return (
    <footer className={$.footer}>
      <div className={$.footer_inner_wrapper}>
        <div></div>
        <div className={$.footer_inner_wrapper_text_box}>
          <hr
            style={{
              border: "none",
              borderTop: "2px solid #6654af",
              margin: "20px 0",
            }}
          />
          <div>
            {" "}
            <span>filinruss@filindevelopment.ca</span>
          </div>
          <br />
          <div>
            {" "}
            <span>© 2024 Filin development. All rights reserved</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
